<template>
  <div class="configuration-file-page ml-2">
    <pc-viewing-trace-doc/>

  </div>
</template>

<script>
  import PcViewingTraceDoc from './PcViewingTraceDoc'

  export default {
    components:{ PcViewingTraceDoc},
    name: 'configuration-file.page',
  }
</script>

